module.exports = __webpack_public_path__ + "img/status-icn_unpublished@3x.d357e8fe.png";